import { isArray } from 'lodash-es';

export class AptFileUploadCtrl {
  // TODO: find better way to dynamically add event bindings
  static bindings = {
    attachments: '<',
    allowDelete: '<',
    onFileSelected: '&',
    onDeleteAttachment: '&',
    multipleFiles: '<',
    acceptableExtensions: '<',
    disabledFileSelection: '<'
  };

  onDeleteAttachment;
  onFileSelected;
  multipleFiles;
  acceptableExtensions: string[];
  disabledFileSelection;
  acceptableExtensionsString: string;

  constructor() {
    'ngInject';
  }

  $onChanges(changes) {
    if (
      changes.acceptableExtensions &&
      Array.isArray(changes.acceptableExtensions.currentValue)
    ) {
      this.updateAcceptableExtensions(
        changes.acceptableExtensions.currentValue
      );
    }
  }

  /**
   * Converts an array of extensions from ['xls', 'xlsx'] to a string '.xls,.xlsx'
   *
   * @param {string[]} extensions [description]
   */
  updateAcceptableExtensions(extensions: string[]) {
    this.acceptableExtensionsString = extensions
      .map((extension) => '.'.concat(extension))
      .join(',');
  }

  /**
   * Call this when a file is selected
   *
   * @param {[type]} $files          Some uploads will support multiple
   * @param {[type]} $file           Some only upload one file
   * @param {[type]} $newFiles       [description]
   * @param {[type]} $duplicateFiles [description]
   * @param {[type]} $invalidFiles   [description]
   * @param {[type]} $event          [description]
   */
  selectFile($files, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    // IMPORTANT: in this implementation we only pass in recently selected files $newFiles. Possibly make this optional;
    // We want to be sure that $newFiles is always an array regardless of single or multiple selection.
    console.assert(isArray($newFiles), 'Files object is not Array', $files);

    this.onFileSelected({ files: $newFiles });
  }

  onDelete(attachment, e) {
    this.onDeleteAttachment({ attachment });
    e.stopPropagation();
  }
}

export const AptFileUploadComponent = {
  replace: true,
  transclude: {
    uploadHeader: '?uploadHeader',
    attachmentHeader: '?attachmentHeader',
    fileListContent: '?fileListContent'
  },
  controller: AptFileUploadCtrl,
  bindings: AptFileUploadCtrl.bindings,
  template: require('./aptFileUpload.component.html')
};
